import { useController } from "react-hook-form";
import clsx from "clsx";
import Select from "components/Select";
import { ControlledSelectProps, OptionType } from ".";

export default function ControlledSingleSelect({
  control,
  name,
  id,
  rules,
  options,
  className,
  variant,
  isClearable = true,
  useBasicStyles = true,
  ...props
}: ControlledSelectProps) {
  const {
    field: { onChange, onBlur, value },
  } = useController({ name, control, rules });
  return (
    <Select
      options={options}
      name={name}
      menuPortalTarget={document.body}
      onChange={(val) => onChange(val?.value)}
      onBlur={onBlur}
      isClearable={isClearable}
      variant={variant}
      useBasicStyles={useBasicStyles}
      classNamePrefix="chakra-react-select"
      className={clsx("chakra-react-select-container-single-select", className)}
      value={options?.find((option) => (option as OptionType).value === value) || null}
      colorScheme="brand"
      {...props}
    />
  );
}
